<template>
  <div>
    <div v-if="!showPrivacyPolicy">
    <v-menu>
      <template #activator="{ props }">
        <v-btn
          style="position: fixed; top: 20px; right: 80px; z-index: 1000;"
          color="primary"
          icon
          size="small"
          v-bind="props"
        >
          <v-icon>mdi-translate</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="changeLanguage('pt')">
          <template #prepend>
            <img src="https://flagcdn.com/w20/pt.png" alt="Portugal" style="width: 24px; height: auto; border-radius: 2px; margin-right: 8px;">
          </template>
          <v-list-item-title>Português</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeLanguage('en')">
          <template #prepend>
            <img src="https://flagcdn.com/w20/gb.png" alt="United Kingdom" style="width: 24px; height: auto; border-radius: 2px; margin-right: 8px;">
          </template>
          <v-list-item-title>English</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeLanguage('es')">
          <template #prepend>
            <img src="https://flagcdn.com/w20/es.png" alt="Spain" style="width: 24px; height: auto; border-radius: 2px; margin-right: 8px;">
          </template>
          <v-list-item-title>Español</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeLanguage('fr')">
          <template #prepend>
            <img src="https://flagcdn.com/w20/fr.png" alt="France" style="width: 24px; height: auto; border-radius: 2px; margin-right: 8px;">
          </template>
          <v-list-item-title>Français</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeLanguage('de')">
          <template #prepend>
            <img src="https://flagcdn.com/w20/de.png" alt="Germany" style="width: 24px; height: auto; border-radius: 2px; margin-right: 8px;">
          </template>
          <v-list-item-title>Deutsch</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeLanguage('zh')">
          <template #prepend>
            <img src="https://flagcdn.com/w20/cn.png" alt="China" style="width: 24px; height: auto; border-radius: 2px; margin-right: 8px;">
          </template>
          <v-list-item-title>中文</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn
      style="position: fixed; top: 20px; right: 20px; z-index: 1000;"
      color="primary"
      icon
      size="small"
      @click="openPrivacyPolicyDialog()"
    >
      <v-icon>mdi-gavel</v-icon>
    </v-btn>
    <v-container class="nmContainer pa-5">
      <v-row justify="center" class="nmVRow">{{ $t('messages.home_title') }}</v-row>
      <v-row justify="center" class="nmVRow2 pa-2 font-weight-thin">{{ $t('messages.home_subtitle') }}</v-row>
    </v-container>
    <v-container>
      <v-row justify="center" class="nmVRow2 pa-1 font-weight-thin">{{ $t('messages.home_alreadyCustomer') }} <span class="mx-1 font-weight-regular">SmartSurf</span> {{ $t('messages.home_customer') }} ?</v-row>
      <v-row justify="center" class="pa-1"><v-btn rounded color="primary" dark @click="openLoginDialog()">{{ $t('messages.home_login') }}</v-btn></v-row>
      <v-row justify="center" class="nmVRow2 pa-1 font-weight-thin">{{ $t('messages.home_startNow') }} <span class="mx-1 font-weight-regular">SmartSurf</span></v-row>
      <v-row justify="center" class="pa-1"><v-btn rounded color="secondary" dark @click="openSignupDialog">{{ $t('messages.home_register') }}</v-btn></v-row>
    
    <SignupDialog />
    </v-container>
    <v-container class="nmContainer pa-6">
      <v-row justify="center" class="nmVRow">{{ $t('messages.home_knowMore') }}</v-row>
      <v-row justify="center" class="nmVRow2 pa-2 font-weight-thin">{{ $t('messages.home_description') }}</v-row>
    </v-container>
    <v-card class="elevation-0">
      <v-container style='font: 400 15px/1.42857143 "Roboto", sans-serif; padding: 20px;'>
        <v-row justify="center" style='font: 300 32px/36px "Roboto", sans-serif'>
          {{ $t('messages.home_features') }}
        </v-row>
        <v-row justify="center" style='font-size: 20px; line-height: 24px; padding-top: 10px;' class="font-weight-light text-center">
          {{ $t('messages.home_featuresDesc') }}
        </v-row>
      </v-container>
      <v-container>
        <v-row dense>
          <v-col cols="12" sm="6" md="4" lg="4"
            v-for="(item, i) in items"
            :key="i"
          >
            <v-card>
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title>
                    <v-icon large color="blue lighten-1">
                      {{ item.icon }}
                    </v-icon>
                  </v-card-title>
                  <v-card-subtitle class="title font-weight-light">{{ item.title }}</v-card-subtitle>
                  <v-card-text style="min-height: 80px;">
                    <div v-text="item.description"></div>
                  </v-card-text>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-container class="nmContainer pa-6">
      <v-row justify="center" class="nmVRow">{{ $t('messages.home_ourTeam') }}</v-row>
      <v-row justify="center" class="nmVRow2 pa-2 font-weight-light text-center">{{ $t('messages.home_teamDesc') }}</v-row>
    </v-container>
    <v-container class="nmContainer pa-6">
      <v-row justify="center" class="nmVRow">
        {{ $t('messages.home_contact') }}
      </v-row>
      <v-row justify="center" class="nmVRow2 pa-4 font-weight-thin">
        {{ $t('messages.home_contactDesc') }}
      </v-row>
      <v-row justify="center" class="nmVRow2 pa-2 font-weight-light text-center">
        <v-icon color="blue lighten-1">mdi-cellphone</v-icon> +351 93 496 10 28
      </v-row>
      <v-row justify="center" class="nmVRow2 pa-2 font-weight-light text-center">
        <v-icon color="blue lighten-1">mdi-at</v-icon> info@smartsurf.pt
      </v-row>
      <v-row justify="center" class="nmVRow2 pa-2 font-weight-light text-center">
        <v-icon color="blue lighten-1">mdi-map-marker</v-icon> Lisbon, Portugal
      </v-row>
    </v-container>
    </div>
    <PrivacyPolicyDialog />
  </div>
</template>

<script>
import PrivacyPolicyDialog from './PrivacyPolicy.vue'
import SignupDialog from '../General/SignupDialog'

export default {
  name: 'StartPage',
  inject: ['bus'],
  data: () => ({
    isLoggedIn: false,
    showPrivacyPolicy: false,
  }),
  computed: {
    items() {
      return [
        {
          icon: 'mdi-currency-eur',
          title: this.$t('messages.home_price'),
          description: this.$t('messages.home_priceDesc'),
        },
        {
          icon: 'mdi-finance',
          title: this.$t('messages.home_monitoring'),
          description: this.$t('messages.home_monitoringDesc'),
        },
        {
          icon: 'mdi-thumb-up',
          title: this.$t('messages.home_usability'),
          description: this.$t('messages.home_usabilityDesc'),
        },
        {
          icon: 'mdi-image-filter-center-focus-strong',
          title: this.$t('messages.home_focus'),
          description: this.$t('messages.home_focusDesc'),
        },
        {
          icon: 'mdi-chart-bar-stacked',
          title: this.$t('messages.home_analytics'),
          description: this.$t('messages.home_analyticsDesc'),
        },
      ]
    }
  },
  mounted () {
    this.bus.on('loggedIn', () => { 
      this.isLoggedIn = true
    })
    this.bus.on('logout', () => {
      this.isLoggedIn = false
    })
    this.bus.on('showPrivacyPolicy', (show) => {
      this.showPrivacyPolicy = show
    })
    if (this.$store.state.email !== "") {
      this.isLoggedIn = true
    }
    if (this.$route.params.login == "true") {
      this.openLoginDialog()
    }
  },
  methods: {
    openLoginDialog() {
      this.bus.emit("loginDialog")
    },
    openPrivacyPolicyDialog() {
      this.bus.emit("privacyPolicyDialog")
    },
    openSignupDialog() {
      this.bus.emit("signupDialog")
    },

    changeLanguage(lang) {
      document.cookie = `smartsurf_language=${lang}; expires=${new Date(Date.now() + 365*24*60*60*1000).toUTCString()}; path=/`
      this.$i18n.locale = lang
      this.$forceUpdate()
    },
  },
  components: {
    PrivacyPolicyDialog,
    SignupDialog
  }
}
</script>

<style>
.nmContainer {
  font: 400 15px/1.42857143 "Roboto", sans-serif;
}
.nmVRow {
  font: 300 32px/36px "Roboto", sans-serif;
}
.nmVRow2 {
  font-size: 20px;
  line-height: 24px;
}
.nmRowPadding {
  padding: 20px;
}
</style>